import React from 'react';
import { IssueReportState } from './common/IssueReportState';
import { reportIssue } from '../platform/support/issueReport';

type Props = {
  name: string;
  children: React.ReactNode;
};

type State = {
  error: Error | null;
  component_stack: string;
};

/**
 * v3 production crash boundary: logs locally and shows IssueReportState (WhatsApp + support copy).
 */
export class IssueReportErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null, component_stack: '' };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    const stack = info.componentStack?.split('\n').slice(0, 12).join('\n') ?? '';
    this.setState({ component_stack: stack });
    reportIssue({
      page: this.props.name,
      issue: 'Render crash',
      kind: 'crash',
      error_message: error.message,
      stack,
    });
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <IssueReportState
          issue_context={{
            page: this.props.name,
            issue: 'App crashed while rendering this screen',
            kind: 'crash',
            error_message: this.state.error.message,
            stack: this.state.component_stack,
          }}
          auto_log={false}
        />
      );
    }
    return this.props.children;
  }
}

export default IssueReportErrorBoundary;
